import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getGamePackageStats,
  GamePackageStatsData,
} from '@/application/requests/gamePackage';

export interface PackageStatsState {
  stats: GamePackageStatsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: PackageStatsState = {
  stats: null,
  loading: false,
  error: null,
};

export const fetchPackageStats = createAsyncThunk(
  'packageStats/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getGamePackageStats();

      if (!response.success || !response.data) {
        return rejectWithValue(
          response.message || 'Failed to fetch package stats'
        );
      }

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch package stats');
    }
  }
);

const packageStatsSlice = createSlice({
  name: 'packageStats',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPackageStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(fetchPackageStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = packageStatsSlice.actions;
export default packageStatsSlice.reducer;
